import React from "react";
export default (props) => (
  <svg
    style={props.style}
    width={props.width || "15px"}
    height={props.width || "20px"}
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 7.5C2.96403e-08 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5C15 12.5 7.5 20 7.5 20C7.5 20 0 12.5 0 7.5ZM4.375 7.5C4.375 8.3288 4.70424 9.12366 5.29029 9.70971C5.87634 10.2958 6.6712 10.625 7.5 10.625C8.3288 10.625 9.12366 10.2958 9.70971 9.70971C10.2958 9.12366 10.625 8.3288 10.625 7.5C10.625 6.6712 10.2958 5.87634 9.70971 5.29029C9.12366 4.70424 8.3288 4.375 7.5 4.375C6.6712 4.375 5.87634 4.70424 5.29029 5.29029C4.70424 5.87634 4.375 6.6712 4.375 7.5Z"
      fill={props.color || "black"}
    />
  </svg>
);
